import ThankYouPage from "@/components/ThankYouPage";

const MerciPlanDeMatch = () => (
  <ThankYouPage
    eventName="Lead"
    contentName="Plan de match"

    title="Votre Plan de match est lancé."
    body={`Vous allez recevoir un courriel dans les prochaines minutes avec le lien pour réserver votre appel de départ.

Préparez vos chiffres : vos dépenses publicitaires, vos résultats, et ce que vous avez essayé avant. Plus vous m'en donnez, plus votre plan va être précis.

Sept jours ouvrables après notre appel, vous avez votre plan.`}
    backTo="/plan-de-match"
    backLabel="Retour au plan de match"
    canonical="/merci/plan-de-match"
  />
);

export default MerciPlanDeMatch;
